export default "__VITE_ASSET__DhADfs3u__"